/**
 * V70-S: `인사관리 > 전사 근로 현황 / 연장 근무 관리` 라우트 가드
 *
 * 허용: system_admin · role_admin_kr · KR 소속 role_hr (shared/utils/hrKrAuditAccess.ts)
 *  - URL 직접 입력도 이 가드를 거친다. ProtectedRoute(ROUTE_PERMISSIONS 'hr.manage')와 함께 쓴다.
 *  - 서버 callable 이 같은 규칙으로 재검증하므로, 이 가드는 화면 노출 제어용이다.
 */
import React from 'react';
import { useCurrentUser } from '../shared/hooks/useCurrentUser';
import { canAccessHrKrAudit } from '../shared/utils/hrKrAuditAccess';

interface Props {
  children: React.ReactElement;
}

export function HrKrAuditAccessGuard({ children }: Props) {
  const { user, isLoading } = useCurrentUser();

  if (isLoading) {
    return (
      <div style={{
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        minHeight: '200px', color: 'var(--color-gray-500)',
      }}>
        권한 확인 중...
      </div>
    );
  }

  if (!canAccessHrKrAudit(user?.roles, user?.profile?.companyCode)) {
    return (
      <div data-testid="hr-kr-audit-denied" style={{ padding: '40px', textAlign: 'center' }}>
        <div style={{ fontSize: '48px', marginBottom: '16px' }}>🔒</div>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: 'var(--color-gray-800)', marginBottom: '12px' }}>
          접근 권한이 없습니다
        </h2>
        <p style={{ color: 'var(--color-gray-600)', marginBottom: '8px' }}>
          이 화면은 KR 인사 담당자, KR 관리자, 시스템 관리자만 이용할 수 있습니다.
        </p>
        <div style={{ marginTop: '24px' }}>
          <button
            onClick={() => window.history.back()}
            style={{
              padding: '8px 24px', background: 'var(--color-primary)', color: 'white',
              border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '14px',
            }}
          >
            뒤로 가기
          </button>
        </div>
      </div>
    );
  }

  return children;
}
